export default "__VITE_ASSET__150b2527__"